export  const formValid = ({formErrors, ...rest}) =>{
    let valid = true;    
    let data = '';
    //validate form errors being empty
    Object.values(formErrors).forEach(val => {
        val.length>0 && (valid=false)
    });
    
    //validate the form was filled out
    if(rest.skillData){
        data = rest.skillData;
        if(data.certificateRequired===false && data.certificateName===null){
            data['certificateName']= '';
        }else if(data.certificateRequired===true && data.certificateName===""){
            data['certificateName']= null;
        }
    }else if(rest.userData){
        data = rest.userData;
    }else if(rest.sectorData){
        data = rest.sectorData;
    }else if(rest.otherExpData){
        data = rest.otherExpData;
    }else if(rest.subSectorData){
        data = rest.subSectorData;
    }else if(rest.rolesData){
        data = rest.rolesData;
    }else if(rest.userDocData){
        data = rest.userDocData;
    }else if(rest.affiliateData){
        if(rest.affiliateData.activeTab==='tab1'){
            data = rest.affiliateData.companyInfo;
        }else if(rest.affiliateData.activeTab==='tab2'){
            data = rest.affiliateData.affiliateAddress;
        }else if(rest.affiliateData.activeTab==='tab3'){
            data = rest.affiliateData.primaryContact;
        }else if(rest.affiliateData.activeTab==='tab4'){
            data = rest.affiliateData.profileSettings;
        }
    }else if(rest.locationData){
        data = rest.locationData;
    }else if(rest.quickData){
        data = rest.quickData;
    }else if(rest.clientData){
        if(rest.clientData.activeTab==='tab1' || rest.clientData.activeTab==='company-info-tab'){
            let compInfo = rest.clientData.companyInfo;
            delete compInfo.noLocationFound; 
            if(!compInfo.googleLocation) delete compInfo.googleLocation;            
            data = compInfo;

            if (compInfo.samePhysicalAddress) {
                const skipFields = ['locationIdBilling',
                    'locationBilling',
                    'googleLocationBilling',
                    'venueBilling',
                    'streetOneBilling',
                    'streetTwoBilling',
                    'cityBilling',
                    'stateBilling',
                    'countryBilling',
                    'postcodeBilling',];
                skipFields.forEach(field => delete data[field]);
            }
        }else if(rest.clientData.activeTab==='tab2' || rest.clientData.activeTab==='company-primary-contact-tab'){
            data = rest.clientData.primaryContact;
        }
    }else if(rest.crewData){
        if(rest.crewData.activeTab==='tab1' || rest.crewData.activeTab==='company-info-tab'){
            data = rest.crewData.basicInfo;
        }
    }else if(rest.contactData){
        data = rest.contactData;
    }else if(rest.eventData){
        data = rest.eventData;
    }else if(rest.shiftData){
        data = rest.shiftData;
    }else if(rest.payLevelData){
        data = rest.payLevelData;
    }else if(rest.ppOmnuData){
        data = rest.ppOmnuData;
    }
    
    Object.values(data).forEach(val =>{
        val===null && (valid = false)
    })
    return valid;
}

export const checkNumDot = (numVal) =>{  
    const re = /^[0-9.]+$/;  
    return (numVal===0 || numVal==='') ? false : (re.test(numVal) ? true : false); 
}

export const checkNumDotZero = (numVal) =>{ 
    const re = /^[0-9.]+$/;  
    return numVal==='' ? false : (re.test(numVal) ? true : false); 
}

export const checkNumColon = (numVal) =>{ 
    const re = /^[0-9:]+$/;  
    return numVal==='' ? false : (re.test(numVal) ? true : false); 
}

export const checkNum = (numVal) =>{ 
    const re = /^[0-9-]+$/;  
    return numVal==='' ? false : (re.test(numVal) ? true : false); 
}

export const mobileRegex = /^[0-9]{1}[0-9]{9}$/;

export const emailRegex = /^([A-Za-z0-9_\-.+*#$%&"'@<>(){}!?^~/|:;=])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,4})$/;

export const decimalNumRegex = /^\d{1,10}(\.\d{1,4})?$/;

export const numRegex = /^\d+$/;

export const imageExtension = (imageName)=>{
    if ( /\.(jpe?g|png|gif)$/i.test(imageName) === false ){
        return false;
    }
    return true;
}
export const fileExtension = (fileName)=>{
    if ( /\.(jpe?g|png|pdf|doc|docx|xlsx|xls)$/i.test(fileName) === false ){
        return false;
    }
    return true;
}

export const fileSize = (size)=>{
    let fileSize = size / 1024 / 1024; // in MB
    if (fileSize > 10) {
        return false;
    }    
    return true;
}

export const csvFileCheck = (imageName)=>{
    if ( /\.(csv)$/i.test(imageName) === false ){
        return false;
    }
    return true;
}

export const validateEmail = (email)  => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
}